// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"jM","navPanel":"jM","nav-panel-bg":"jN","navPanelBg":"jN","nav-panel-content":"jO","navPanelContent":"jO","none":"jP","block":"jQ"};